import { createRoute } from "@tanstack/react-router"

import { UiShowcase } from "../../ui/showcase/ui-showcase"
import { rootRoute } from "./root-route"

/**
 * Витрина библиотеки элементов.
 *
 * ПОЧЕМУ ВНЕ ЗАЩИЩЁННОЙ ОБЛАСТИ. Витрина не показывает ни одной записи, ни одного
 * клиента и ни одного салона — только собственные демонстрационные строки из макета.
 * Данных за ней нет, а нужна она там, где учётной записи салона нет ни у кого:
 * на приёмке у дизайнера, у переводчика при проверке немецких строк, у разработчика,
 * которому надо свериться с эталоном. Прятать её за входом значило бы закрыть её
 * ровно от тех, кому она нужна.
 *
 * Собственного права раздела у неё нет по той же причине: права выдаются к данным,
 * а данных здесь нет.
 */
export const uiShowcaseRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/ui",
  component: UiShowcase,
})
